import { ListTenantsResponseSchema } from './list-tenants.schema';
/**
 * List Tenants Endpoint Contract
 * Fetches all tenants in the system
 * Restricted to super-admin users only
 */ export const listTenantsContract = {
    method: 'GET',
    path: '/api/v2/tenants',
    description: 'Fetches all tenants in the system (super-admin only)',
    responseSchema: ListTenantsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - user is not a super-admin'
        }
    }
};

//# sourceMappingURL=list-tenants.contract.js.map